import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";
var _templateObject;
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import { css } from '@emotion/react';
import { TaskDecisionSharedCssClassName } from '@atlaskit/editor-common/styles';
import { akEditorDeleteBackgroundWithOpacity, akEditorDeleteBorder, akEditorSelectedBorderSize, akEditorSelectedNodeClassName, getSelectionStyles, SelectionStyle } from '@atlaskit/editor-shared-styles';
// eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export var taskDecisionStyles = css(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n\t[data-decision-wrapper] {\n\t\tcursor: pointer;\n\t}\n\n\t.", " > [data-decision-wrapper],\n\tol[data-node-type='decisionList'].", " {\n\t\tborder-radius: 4px;\n\t\t", "\n\t}\n\n\t.danger {\n\t\t.", ".", " > div {\n\t\t\tbox-shadow: 0 0 0 ", "px\n\t\t\t\t", ";\n\t\t\tbackground-color: ", ";\n\t\t\t&::after {\n\t\t\t\tcontent: none; /* reset the Blanket selection style */\n\t\t\t}\n\t\t}\n\t}\n"])), akEditorSelectedNodeClassName, akEditorSelectedNodeClassName, getSelectionStyles([SelectionStyle.BoxShadow, SelectionStyle.Blanket]), TaskDecisionSharedCssClassName.DECISION_CONTAINER, akEditorSelectedNodeClassName, akEditorSelectedBorderSize, "var(--ds-border-danger, ".concat(akEditorDeleteBorder, ")"), "var(--ds-blanket-danger, ".concat(akEditorDeleteBackgroundWithOpacity, ")"));

// Combine this with taskDecisionStyles (above) when cleaning up the platform_editor_vanilla_dom experiment.
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export var vanillaTaskDecisionStyles = css({
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
  '[data-prosemirror-node-view-type="vanilla"][data-prosemirror-node-name="decisionItem"]': {
    listStyleType: 'none'
  },
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
  '[data-prosemirror-node-view-type="vanilla"][data-prosemirror-node-name="decisionItem"] > [data-decision-wrapper]': {
    display: 'flex',
    flexDirection: 'row',
    margin: "var(--ds-space-100, 8px)".concat(" 0 0 0"),
    padding: "var(--ds-space-100, 8px)",
    paddingLeft: "var(--ds-space-150, 12px)",
    borderRadius: "var(--ds-border-radius-100, 4px)",
    backgroundColor: "var(--ds-background-neutral, #091E420F)",
    position: 'relative'
  },
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
  '[data-prosemirror-node-view-type="vanilla"][data-prosemirror-node-name="decisionItem"] > [data-decision-wrapper] > [data-component="icon"]': {
    flex: '0 0 16px',
    height: '16px',
    width: '16px',
    margin: "var(--ds-space-050, 4px)".concat(" ", "var(--ds-space-150, 12px)", " 0 0"),
    color: "var(--ds-icon-subtle, #626F86)",
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors, @atlaskit/ui-styling-standard/no-nested-selectors
  '[data-prosemirror-node-view-type="vanilla"][data-prosemirror-node-name="decisionItem"]:not(:has([data-empty]):not(:has([data-type-ahead]))) > [data-decision-wrapper] > [data-component="icon"]': {
    color: "var(--ds-icon-success, #22A06B)"
  },
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
  '[data-prosemirror-node-view-type="vanilla"][data-prosemirror-node-name="decisionItem"] > [data-decision-wrapper] > [data-component="icon"] > span': {
    display: 'inline-block',
    flexShrink: 0,
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography -- Mirroring icon styles
    lineHeight: 1
  },
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
  '[data-prosemirror-node-view-type="vanilla"][data-prosemirror-node-name="decisionItem"] > [data-decision-wrapper] > [data-component="icon"] > span > svg': {
    overflow: 'hidden',
    pointerEvents: 'none',
    color: 'currentColor',
    verticalAlign: 'bottom'
  },
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
  '[data-prosemirror-node-view-type="vanilla"][data-prosemirror-node-name="decisionItem"] > [data-decision-wrapper] > [data-component="placeholder"]': {
    margin: "0 0 0 calc(".concat("var(--ds-space-100, 8px)", " * 3.5)"),
    position: 'absolute',
    color: "var(--ds-text-subtlest, #626F86)",
    pointerEvents: 'none',
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    maxWidth: 'calc(100% - 50px)'
  },
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors, @atlaskit/ui-styling-standard/no-nested-selectors
  '[data-prosemirror-node-view-type="vanilla"][data-prosemirror-node-name="decisionItem"]:not(:has([data-empty]):not(:has([data-type-ahead]))) > [data-decision-wrapper] > [data-component="placeholder"]': {
    display: 'none'
  },
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
  '[data-prosemirror-node-view-type="vanilla"][data-prosemirror-node-name="decisionItem"] > [data-decision-wrapper] > [data-component="content"]': {
    margin: 0,
    wordWrap: 'break-word',
    minWidth: 0,
    flex: '1 1 auto'
  }
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles
export var vanillaTaskDecisionIconWithVisualRefresh = css({
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
  '[data-prosemirror-node-view-type="vanilla"][data-prosemirror-node-name="decisionItem"] > [data-decision-wrapper] > [data-component="icon"] > span >  svg[data-icon-source="legacy"]': {
    display: 'none'
  },
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
  '[data-prosemirror-node-view-type="vanilla"][data-prosemirror-node-name="decisionItem"] > [data-decision-wrapper] > [data-component="icon"] > span': {
    boxSizing: 'border-box',
    paddingInlineEnd: 'var(--ds--button--new-icon-padding-end, 0)',
    paddingInlineStart: 'var(--ds--button--new-icon-padding-start, 0)',
    '@media screen and (forced-colors: active)': {
      color: 'canvastext',
      filter: 'grayscale(1)'
    }
  },
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
  '[data-prosemirror-node-view-type="vanilla"][data-prosemirror-node-name="decisionItem"] > [data-decision-wrapper] > [data-component="icon"] > span > svg': {
    width: "var(--ds-space-300, 24px)",
    height: "var(--ds-space-300, 24px)"
  }
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles
export var vanillaTaskDecisionIconWithoutVisualRefresh = css({
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
  '[data-prosemirror-node-view-type="vanilla"][data-prosemirror-node-name="decisionItem"] > [data-decision-wrapper] > [data-component="icon"] > span >  svg[data-icon-source="refreshed"]': {
    display: 'none'
  },
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
  '[data-prosemirror-node-view-type="vanilla"][data-prosemirror-node-name="decisionItem"] > [data-decision-wrapper] > [data-component="icon"] > span': {
    width: '32px',
    height: '32px',
    '@media screen and (forced-colors: active)': {
      filter: 'grayscale(1)',
      color: 'canvastext',
      fill: 'canvas'
    }
  },
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
  '[data-prosemirror-node-view-type="vanilla"][data-prosemirror-node-name="decisionItem"] > [data-decision-wrapper] > [data-component="icon"] > span > svg': {
    maxWidth: '100%',
    maxHeight: '100%',
    fill: "var(--ds-surface, #FFFFFF)",
    width: '32px',
    height: '32px'
  }
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles
export var vanillaTaskItemStyles = css(_defineProperty({
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
  '[data-prosemirror-node-view-type="vanilla"][data-prosemirror-node-name="taskItem"]': {
    listStyle: 'none'
  },
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
  '[data-prosemirror-node-view-type="vanilla"][data-prosemirror-node-name="taskItem"] [data-component="task-item-main"]': {
    display: 'flex',
    flexDirection: 'row',
    position: 'relative'
  },
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
  '[data-prosemirror-node-view-type="vanilla"][data-prosemirror-node-name="taskItem"] [data-component="placeholder"]': {
    position: 'absolute',
    color: "var(--ds-text-subtlest, #626F86)",
    margin: "0 0 0 calc(".concat("var(--ds-space-100, 8px)", " * 3)"),
    pointerEvents: 'none',
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    maxWidth: 'calc(100% - 50px)',
    display: 'none'
  },
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
  '[data-prosemirror-node-view-type="vanilla"][data-prosemirror-node-name="taskItem"]:has([data-empty]):not(:has([data-type-ahead])) [data-component="placeholder"]': {
    display: 'block'
  },
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
  '[data-prosemirror-node-view-type="vanilla"][data-prosemirror-node-name="taskItem"] [data-component="content"]': {
    margin: 0,
    wordWrap: 'break-word',
    minWidth: 0,
    flex: '1 1 auto'
  },
  // copied styles from packages/design-system/icon/src/components/icon-new.tsx
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
  '[data-prosemirror-node-view-type="vanilla"][data-prosemirror-node-name="taskItem"] [data-component="checkbox-icon-wrap"]': {
    display: 'inline-block',
    boxSizing: 'border-box',
    flexShrink: 0,
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    lineHeight: 1,
    paddingInlineEnd: 'var(--ds--button--new-icon-padding-end, 0)',
    paddingInlineStart: 'var(--ds--button--new-icon-padding-start, 0)'
  },
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
  '[data-prosemirror-node-view-type="vanilla"][data-prosemirror-node-name="taskItem"] [data-component="checkbox-icon-wrap"] svg': {
    overflow: 'hidden',
    pointerEvents: 'none',
    color: 'currentColor',
    verticalAlign: 'bottom',
    width: "var(--ds-space-200, 16px)",
    height: "var(--ds-space-200, 16px)"
  },
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
  '[data-prosemirror-node-view-type="vanilla"][data-prosemirror-node-name="taskItem"] input[type=checkbox]:not(:checked) + span [data-component=checkbox-checked-icon]': {
    display: 'none'
  },
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
  '[data-prosemirror-node-view-type="vanilla"][data-prosemirror-node-name="taskItem"] input[type=checkbox]:not(:checked) + span [data-component=checkbox-unchecked-icon]': {
    display: 'inline'
  },
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
  '[data-prosemirror-node-view-type="vanilla"][data-prosemirror-node-name="taskItem"] input[type=checkbox]:checked + span [data-component=checkbox-checked-icon]': {
    display: 'inline'
  },
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
  '[data-prosemirror-node-view-type="vanilla"][data-prosemirror-node-name="taskItem"] input[type=checkbox]:checked + span [data-component=checkbox-unchecked-icon]': {
    display: 'none'
  }
}, "[data-prosemirror-node-view-type=\"vanilla\"][data-prosemirror-node-name=\"taskItem\"] .".concat(TaskDecisionSharedCssClassName.TASK_CHECKBOX_CONTAINER), {
  flex: '0 0 24px',
  width: '24px',
  height: '24px',
  position: 'relative',
  alignSelf: 'start',
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
  "& > input[type='checkbox']": {
    width: '16px',
    height: '16px',
    zIndex: 1,
    cursor: 'pointer',
    outline: 'none',
    margin: 0,
    opacity: 0,
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&[disabled]': {
      cursor: 'default'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '+ span': {
      width: '24px',
      height: '24px',
      position: 'absolute',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '+ span > svg': {
      boxSizing: 'border-box',
      display: 'inline',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
      maxWidth: 'unset',
      maxHeight: 'unset',
      position: 'absolute',
      overflow: 'hidden',
      color: "var(--ds-background-input, #FFFFFF)",
      transition: 'color 0.2s ease-in-out, fill 0.2s ease-in-out',
      // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
      'path:first-of-type': {
        visibility: 'hidden'
      },
      // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
      'rect:first-of-type': {
        stroke: "var(--ds-border-input, #8590A2)",
        strokeWidth: 1,
        transition: 'stroke 0.2s ease-in-out'
      }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '&:hover + span > svg': {
      color: "var(--ds-background-input-hovered, #F7F8F9)",
      // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
      'rect:first-of-type': {
        stroke: "var(--ds-border-input, #8590A2)"
      }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '&:checked:hover + span > svg': {
      color: "var(--ds-background-selected-bold-hovered, #0055CC)",
      fill: "var(--ds-icon-inverse, #FFFFFF)",
      // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
      'rect:first-of-type': {
        stroke: "var(--ds-background-selected-bold-hovered, #0055CC)"
      }
    },
    '&:checked': {
      // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
      '+ span > svg': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        'path:first-of-type': {
          visibility: 'visible'
        },
        color: "var(--ds-background-selected-bold, #0C66E4)",
        fill: "var(--ds-icon-inverse, #FFFFFF)",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        'rect:first-of-type': {
          stroke: "var(--ds-background-selected-bold, #0C66E4)"
        }
      }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&:active + span > svg': {
      color: "var(--ds-background-input-pressed, #FFFFFF)",
      // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
      'rect:first-of-type': {
        stroke: "var(--ds-border, #091E4224)"
      }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&:checked:active + span > svg': {
      color: "var(--ds-background-input-pressed, #FFFFFF)",
      fill: "var(--ds-icon-inverse, #FFFFFF)",
      // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
      'rect:first-of-type': {
        stroke: "var(--ds-border, #091E4224)"
      }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&:disabled + span > svg, &:disabled:hover + span > svg, &:disabled:focus + span > svg, &:disabled:active + span > svg': {
      color: "var(--ds-background-disabled, #091E4208)",
      // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
      'rect:first-of-type': {
        stroke: "var(--ds-background-disabled, #091E4208)"
      }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&:disabled:checked + span > svg': {
      fill: "var(--ds-icon-disabled, #091E424F)"
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&:focus + span::after': {
      position: 'absolute',
      width: "var(--ds-space-200, 16px)",
      height: "var(--ds-space-200, 16px)",
      border: "2px solid ".concat("var(--ds-border-focused, #388BFF)"),
      borderRadius: "var(--ds-space-050, 4px)",
      content: "''",
      display: 'block',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)'
    }
  }
}));